// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";

import "trix";
import "@rails/actiontext";
import "./channels";

import SimpleBar from "simplebar";
document.addEventListener("turbo:load", () => {
  document.querySelectorAll("[data-simplebar]").forEach((element) => {
    // Avoid re-initializing existing SimpleBar instances
    if (!element.hasAttribute("data-simplebar-initialized")) {
      new SimpleBar(element);
      element.setAttribute("data-simplebar-initialized", "true");
    }
  });
});
